import styles from './main.module.css';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { TextEditor } from '../shared/text-editor';
import * as FileService from 'services/file';
import { SimpleInput } from 'app/shared/input';

export const MainForm = ({
  titleValue,
  value,
  onEditorChange,
  onContinue = () => {},
  onTitleChange = () => {},
  draft_status = '',
  is_continue_disabled = false
}) => {
  const { token } = useSelector((state) => state.user_data);

  useEffect(() => {
    onEditorChange('body', value);
  }, []);

  const uploadImage = (blobInfo, success, failure, progress) => {
    const data = new FormData();
    data.append('image', blobInfo.blob());
    FileService.uploadTinyMCEImage(success, failure, progress, { data, token });
  };

  return (
    <TextEditor
      default_value={value}
      onContinue={onContinue}
      onTextChange={(text) => onEditorChange('body', text)}
      onImageUpload={uploadImage}
      auto_complete_options={[]}
      placeholder="Start creating..."
      isContinueDisabled={is_continue_disabled}
      statusSlot={
        draft_status ? (
          <>
            <span
              style={{
                width: 6,
                height: 6,
                borderRadius: '50%',
                background: 'var(--warning, #f5a623)',
                display: 'inline-block',
                flexShrink: 0
              }}
            />
            {draft_status}
          </>
        ) : null
      }
      titleSlot={
        <SimpleInput
          className={styles.titleInput}
          onInput={onTitleChange}
          value={titleValue}
          placeholder="Email Subject"
        />
      }
    />
  );
};
